<img [src]="thumbnailUrl" [alt]="getFileName()" class="thumbnail" *ngIf="!invalidFile && hasThumbnail" />
<em class="material-icons attach-file" *ngIf="!invalidFile && !hasThumbnail">insert_drive_file</em>
<em class="material-icons broken-file" *ngIf="invalidFile">broken_image</em>

<div class="filename" [class.saved-file]="isFileSaved()">{{ getFileName() }}</div>

<em class="material-icons delete-file-btn" (click)="onDeleteFileBtnClick($event)">close</em>
